import React from "react";
import {Form, DatePicker, TimePicker, Checkbox, Button, Space} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import dayjs from "dayjs";

const {Item, List} = Form;

const EventDatesFormList = () => {
    const form = Form.useFormInstance(); // Get parent form instance

    return (
        <List name="event_dates">
            {(fields, {add, remove}) => (
                <>
                    {fields.map(({key, name, ...restField}) => (
                        <Space key={key} align="start" style={{display: "flex", marginBottom: 8}}>
                            {/* Date Picker */}
                            <Item
                                {...restField}
                                name={[name, "date"]}
                                rules={[{required: true, message: "Date required"}]}
                            >
                                <DatePicker/>
                            </Item>

                            {/* Time Pickers with dynamic disabling based on all_day */}
                            <Item noStyle shouldUpdate>
                                {() => {
                                    const fieldValue = form.getFieldValue(["event_dates", name]) || {};
                                    const isAllDay = fieldValue?.all_day;

                                    return (
                                        <>
                                            <Item {...restField} name={[name, "start_time"]}>
                                                <TimePicker format="HH:mm" placeholder="Start"/>
                                            </Item>

                                            <Item {...restField} name={[name, "end_time"]}>
                                                <TimePicker format="HH:mm" placeholder="End"/>
                                            </Item>
                                        </>
                                    );
                                }}
                            </Item>

                            {/* All Day Checkbox */}
                            <Item {...restField} name={[name, "all_day"]} valuePropName="checked">
                                <Checkbox
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        const currentDates = form.getFieldValue("event_dates") || [];
                                        const updated = [...currentDates];

                                        if (checked) {
                                            updated[name] = {
                                                ...updated[name],
                                                all_day: true,
                                                start_time: dayjs("00:00", "HH:mm"),
                                                end_time: dayjs("23:59", "HH:mm"),
                                            };
                                        } else {
                                            updated[name] = {
                                                ...updated[name],
                                                all_day: false,
                                                start_time: undefined,
                                                end_time: undefined,
                                            };
                                        }

                                        form.setFieldsValue({event_dates: updated});
                                    }}
                                >
                                    All Day
                                </Checkbox>
                            </Item>

                            {/* Remove Button */}
                            <MinusCircleOutlined onClick={() => remove(name)} style={{marginTop: 8}}/>
                        </Space>
                    ))}

                    {/* Add Button */}
                    <Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined/>}>
                            Add Date
                        </Button>
                    </Item>
                </>
            )}
        </List>
    );
};

export default EventDatesFormList;
